import { isObjectV2 } from '@mimir/primitive/type-guards/isObject';
import { invariant } from '@mimir/common/util/invariant';
import type { ArtifactReference } from '@mimir/primitive/artifactReference';
import type { ProjectItemInfo } from '@mimir/primitive/nle/projectItem';
import { MIMIR_ARTIFACT_KEY } from '@mimir/primitive/nle/metadata';


export function projectItemArtifactReference(projectItemInfo: ProjectItemInfo): ArtifactReference | null {
  const artRefJson = projectItemInfo.meta[MIMIR_ARTIFACT_KEY];
  if (artRefJson) {
    return interpretArtifactReference(artRefJson);
  }
  return null;
}

function interpretArtifactReference(artRefJson: string): ArtifactReference | null {
  const unk: unknown = JSON.parse(artRefJson);
  invariant(isObjectV2(unk), 'Expected artifact reference to be object.');
  const partial = unk as { type?: unknown };
  invariant(typeof partial.type === 'string', 'Expected artifact reference type identifier to be string.');

  // Filter out legacy ImplicitReference stored in old .prproj files — treat as absent.
  if (partial.type === 'ImplicitReference') {
    return null;
  }

  const artRef = partial as ArtifactReference;
  // Since the JSON specs do not allow undefined values, JSON.parse() can never produce
  // an undefined value for the highResExt property of an artifact reference that had been
  // stringified before. Since the highResExt property is marked as mandatory, we need to
  // explicitly add the undefined property (otherwise deep equal comparisons will fail)
  if (artRef.type === 'TsSegmentRange' && artRef.highResExt === undefined) {
    artRef.highResExt = undefined;
  }
  return artRef;
}
